<div class="content">
    <!-- Begin dashboard -->
    <div class="container-fluid">
        <!-- Page Heading -->
        <div class="row">
            <div class="col d-flex align-items-center justify-content-between mb-4">
                <h1 class="dashboard-title">Reports</h1>
            </div>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-12 d-flex align-items-center report-listing-toolbar">
                <!-- Search Box -->
                <div class="col-lg-6 col-md-6 report-search-column"
                 [ngClass]="{
                    'col-lg-5': reportType === 'CUSTOM_REPORT',
                    'col-lg-6': reportType !== 'CUSTOM_REPORT'
                }">

                    <div class="google-search-container">

                      <i class="fa fa-search search-icon"></i>

                      <input
                        (keyup)="handleKeyUp($event)"
                        #searchBox
                        class="google-search-input"
                        type="text"
                        placeholder="Search reports..."
                      />

                      <i
                        *ngIf="searchBox.value"
                        class="fa fa-times clear-icon"
                        (click)="clearSearch(searchBox)"
                      ></i>

                    </div>
                </div>

                <!-- Dropdown -->
                <div class="col-md-12 report-selector-column"
                [ngClass]="{
                    'col-lg-5': reportType === 'CUSTOM_REPORT',
                    'col-lg-3': reportType !== 'CUSTOM_REPORT'
                }">
                    <select class="form-control custom-select report-type-select" placeholder="Select header" [(ngModel)]="reportType" (change)="setReportType(reportType)">
                        <option value="" disabled>Select Type</option>
                        <option *ngFor="let item of reportTypeArray" [value]="item.value">
                            {{ item.viewValue }}
                        </option>
                    </select>
                    <!--<mat-form-field *ngIf="reportType === 'CUSTOM_REPORT'" appearance="outline" class="custom-mat-form-field">
                        <mat-label>Select Options</mat-label>
                        <mat-select [(ngModel)]="selectedHeaders" multiple (selectionChange)="updateSelectedHeaders($event)">
                            <mat-option *ngFor="let option of headerArray; trackBy: trackByHeader" [value]="option.enumValue">
                                {{ option.displayName }}
                            </mat-option>
                        </mat-select>
                        <span matSuffix class="d-flex ">
                            <button mat-button color="primary" (click)="setHeader(true); $event.stopPropagation()" [disabled]="selectedHeaders.length === 0">
                                select
                            </button>
                        </span>
                    </mat-form-field>-->


                    <div
                    *ngIf="reportType === 'CUSTOM_REPORT'"
                    class="report-header-picker">

                    <mat-form-field
                        appearance="outline"
                        class="custom-mat-form-field report-header-select">

                        <mat-select
                        [(ngModel)]="selectedHeaders"
                        multiple
                        placeholder="Select Headers"
                        (selectionChange)="updateSelectedHeaders($event)">

                        <mat-select-trigger>
                            <span class="report-header-trigger">
                            {{ getSelectedHeaderNames() }}
                            </span>
                        </mat-select-trigger>

                        <mat-option
                            *ngFor="let option of headerArray; trackBy: trackByHeader"
                            [value]="option.enumValue">

                            <span class="option-text">

                            <span
                                *ngIf="getSequenceNumber(option.enumValue)"
                                class="sequence-number">
                                {{ getSequenceNumber(option.enumValue) }}.
                            </span>

                            {{ option.displayName }}

                            </span>

                        </mat-option>

                        </mat-select>

                    </mat-form-field>

                    <button
                        type="button"
                        class="listing-btn listing-btn-secondary listing-btn-icon report-header-apply"
                        [disabled]="selectedHeaders.length === 0"
                        (click)="setHeader(true)"
                        title="Apply selected headers">

                        <i class="fa-solid fa-check"></i>

                    </button>

                    </div>


                    <div *ngIf="reportType=== 'DAY_END_CLIENT_REPORT' || reportType === 'TOTAL_WORK_ORDER_ALLOCATED_BY_DAY' " class="form-group mb-0">
                        <input type="text" id="date" class="form-control"
                               placeholder="Date" bsDatepicker [(ngModel)]="date" (bsValueChange)="_fetchData()"
                               [bsConfig]="{rangeInputFormat: 'MM-DD-YYYY', placement: 'right', containerClass: 'theme-blue'}">
                    </div>
                </div>

                <!-- Filter and Add Buttons -->
                <div
                class="col-md-12 col-sm-12 report-actions-column"
                [ngClass]="reportType === 'CUSTOM_REPORT' ? 'col-lg-2' : 'col-lg-3'">

                <div class="report-action-bar">

                    <!-- FILTER -->
                    <div
                    *ngIf="reportType === 'CUSTOM_REPORT'"
                    class="report-filter-wrapper"
                    #dropdownContainer>

                    <button
                        type="button"
                        class="listing-btn listing-btn-secondary listing-filter-btn"
                        [class.active]="isDropdownOpen"
                        (click)="toggleDropdown()"
                        title="Filters">

                        <i class="fa-solid fa-sliders"></i>

                        <span class="listing-btn-label">
                        Filters
                        </span>

                        <span
                        *ngIf="filterType"
                        class="listing-filter-count">
                        1
                        </span>

                    </button>


                    <!-- NEW FILTER POPOVER -->
                    <div
                        class="report-filter-popover"
                        *ngIf="isDropdownOpen"
                        (click)="$event.stopPropagation()">

                        <!-- Header -->
                        <div class="report-filter-header">

                        <div>
                            <div class="report-filter-title-row">

                            <span class="report-filter-title">
                                Filters
                            </span>

                            <span
                                *ngIf="filterType"
                                class="report-filter-active-badge">
                                Active
                            </span>

                            </div>

                            <div class="report-filter-subtitle">
                            Choose report criteria and apply the filter.
                            </div>
                        </div>

                        <button
                            type="button"
                            class="report-filter-close"
                            (click)="toggleDropdown()">

                            <i class="fa-solid fa-xmark"></i>

                        </button>

                        </div>


                        <!-- Body -->
                        <div class="report-filter-body">

                        <!-- DATE -->
                        <div class="report-filter-section">

                            <div class="report-filter-section-heading">

                            <span class="report-filter-section-icon">
                                <i class="fa-regular fa-calendar"></i>
                            </span>

                            <div>
                                <div class="report-filter-section-title">
                                Date
                                </div>

                                <div class="report-filter-section-hint">
                                Filter records by date range.
                                </div>
                            </div>

                            </div>

                            <div class="report-filter-date-grid">

                            <div class="report-filter-field">
                                <label>From</label>

                                <input
                                type="text"
                                #startDateInput
                                class="form-control report-filter-input"
                                placeholder="MM/DD/YYYY"
                                bsDatepicker
                                [(ngModel)]="startDate"
                                (focus)="markDateFilterActive()"
                                [bsConfig]="{
                                    dateInputFormat: 'MM/DD/YYYY',
                                    placement: 'bottom',
                                    containerClass: 'theme-blue'
                                }">
                            </div>

                            <div class="report-filter-field">
                                <label>To</label>

                                <input
                                type="text"
                                #endDateInput
                                class="form-control report-filter-input"
                                placeholder="MM/DD/YYYY"
                                bsDatepicker
                                [(ngModel)]="endDate"
                                (focus)="markDateFilterActive()"
                                [minDate]="startDate"
                                [bsConfig]="{
                                    dateInputFormat: 'MM/DD/YYYY',
                                    placement: 'bottom',
                                    containerClass: 'theme-blue'
                                }">
                            </div>

                            </div>

                        </div>


                        <!-- STATUS -->
                        <div class="report-filter-section report-filter-compact">

                            <div class="report-filter-label">
                            Status
                            </div>

                            <div class="report-filter-choice-grid three">

                            <button
                                type="button"
                                class="report-filter-choice"
                                [class.active]="filterType === 'active'"
                                (click)="setFilterType('active')">
                                Active
                            </button>

                            <button
                                type="button"
                                class="report-filter-choice"
                                [class.active]="filterType === 'inactive'"
                                (click)="setFilterType('inactive')">
                                Inactive
                            </button>

                            <button
                                type="button"
                                class="report-filter-choice"
                                [class.active]="filterType === 'all'"
                                (click)="setFilterType('all')">
                                All
                            </button>

                            </div>

                        </div>


                        <!-- VERIFICATION -->
                        <div class="report-filter-section report-filter-compact">

                            <div class="report-filter-label">
                            Verification
                            </div>

                            <div class="report-filter-choice-grid">

                            <button
                                type="button"
                                class="report-filter-choice"
                                [class.active]="filterType === 'VERIFIED'"
                                (click)="setFilterType('VERIFIED')">
                                Verified
                            </button>

                            <button
                                type="button"
                                class="report-filter-choice"
                                [class.active]="filterType === 'PENDING'"
                                (click)="setFilterType('PENDING')">
                                Pending
                            </button>

                            <button
                                type="button"
                                class="report-filter-choice"
                                [class.active]="filterType === 'NOT_VERIFIED'"
                                (click)="setFilterType('NOT_VERIFIED')">
                                Not Verified
                            </button>

                            </div>

                        </div>


                        <!-- AGENT -->
                        <div class="report-filter-section report-filter-compact">

                            <div class="report-filter-label">
                            Agent
                            </div>

                            <mat-form-field
                            appearance="outline"
                            class="report-filter-select w-100">

                            <mat-select
                                [(ngModel)]="userId"
                                placeholder="Search and select agent"
                                (selectionChange)="onAgentFilterChange()">

                                <mat-select-filter
                                #filterSelect
                                [array]="agentArray"
                                [displayMember]="'fullName'"
                                (filteredReturn)="onFilteredReturn($event)"
                                (click)="$event.stopPropagation()">
                                </mat-select-filter>

                                <mat-option
                                *ngFor="let agent of filterAgentArray; trackBy: trackByFn"
                                [value]="agent.id">

                                {{ agent.firstName }}
                                {{ agent.lastName }}

                                </mat-option>

                            </mat-select>

                            </mat-form-field>

                        </div>


                        <!-- CARRIER -->
                        <div class="report-filter-section report-filter-compact">

                            <div class="report-filter-label">
                            Carrier
                            </div>

                            <mat-form-field
                            appearance="outline"
                            class="report-filter-select w-100">

                            <mat-select
                                [(ngModel)]="payerId"
                                placeholder="Search and select carrier"
                                [panelClass]="'virtual-scroll-panel'"
                                (selectionChange)="onPayerFilterChange()">

                                <mat-select-filter
                                #filterSelect
                                [array]="payerArray"
                                [displayMember]="'name'"
                                (filteredReturn)="onPayerFilteredReturn($event)"
                                (click)="$event.stopPropagation()">
                                </mat-select-filter>

                                <div class="virtual-scroll-container">

                                <cdk-virtual-scroll-viewport
                                    itemSize="50"
                                    class="virtual-scroll"
                                    [style.height.px]="300">

                                    <mat-option
                                    *cdkVirtualFor="let payer of filterPayerArray"
                                    [value]="payer.id">

                                    {{ payer.name }}

                                    </mat-option>

                                </cdk-virtual-scroll-viewport>

                                </div>

                            </mat-select>

                            </mat-form-field>

                        </div>

                        </div>


                        <!-- FOOTER -->
                        <div class="report-filter-footer">

                        <button
                            type="button"
                            class="listing-btn listing-btn-secondary"
                            (click)="resetFilter($event)">

                            <i class="fa-solid fa-rotate-left"></i>
                            Reset

                        </button>

                        <button
                            type="button"
                            class="listing-btn listing-btn-primary"
                            (click)="applyReportFilter()">

                            <i class="fa-solid fa-check"></i>
                            Apply Filters

                        </button>

                        </div>

                    </div>

                    </div>


                    <!-- ADD HEADER -->
                    <button
                    *ngIf="reportType === 'CUSTOM_REPORT'"
                    class="listing-btn listing-btn-secondary listing-btn-icon"
                    type="button"
                    routerLink="/header"
                    title="Add Header">

                    <i class="fa-solid fa-heading"></i>

                    </button>


                    <!-- EXPORT -->
                    <button
                    class="listing-btn listing-btn-primary listing-btn-icon"
                    type="button"
                    title="Download Report"
                    [disabled]="!authService.hasRole('client-edit')"
                    (click)="exportData()">

                    <i class="fa-solid fa-download"></i>

                    </button>

                </div>

                </div>
            </div>


            <!-- Table -->
            <div class="col-12">
                                <div class="table-panel p-4">
                                    <div class="table-responsive table-scroll-x">
                                        <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                                            <thead>
                                            <tr>
                                                <th *ngFor="let header of getHeaders; trackBy: trackByHeader"
                                                    [mat-sort-header]="header?.fieldName"
                                                    scope="col"
                                                    class="mat-body-1">
                                                    {{ header?.displayName }}
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr *ngFor="let table of tableData; let i = index; trackBy: trackByIndex">
                                                <td *ngFor="let header of getHeaders; trackBy: trackByHeader">
                                                    {{ table[header.fieldName] !== null && table[header.fieldName] !== undefined && table[header.fieldName] !== '' ? table[header.fieldName] : '-' }}
                                                </td>
                                            </tr>
                                            </tbody>
                                            <tbody *ngIf="tableData?.length === 0">
                                            <tr>
                                                <td [attr.colspan]="getHeaders?.length" class="text-center"> No record found !</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div *ngIf="tableData?.length !== 0" class="d-flex justify-content-end mt-3">
                                        <mat-paginator
                                                [length]="totalRecord"
                                                [pageIndex]="pagination.currentPage"
                                                [pageSize]="pagination.size"
                                                [pageSizeOptions]="[5, 10, 25, 100]"
                                                aria-label="Select page"
                                                showFirstLastButtons
                                                color="warn"
                                                (page)="pageChange($event)">
                                        </mat-paginator>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
